/* VANTA — interactions du portage (couleur, lots, panier, FAQ, lightbox) */
(function () {
  'use strict';

  var fmtMoney = function (cents, symbol) {
    return symbol + (cents / 100).toFixed(2);
  };
  /* Devise du visiteur (Shopify Markets) : Intl quand disponible. */
  var fmtMoneyCurrency = function (cents, iso, symbol) {
    var currency = iso || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active);
    if (currency && window.Intl && Intl.NumberFormat) {
      try {
        return new Intl.NumberFormat('en-CA', { style: 'currency', currency: currency }).format(cents / 100);
      } catch (e) { /* devise non supportée par Intl : repli symbole */ }
    }
    return fmtMoney(cents, symbol);
  };

  /* ---------- Révélation au scroll ---------- */
  var revealObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries, io) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                e.target.classList.add('is-visible');
                io.unobserve(e.target);
              }
            });
          },
          { threshold: 0.12 }
        )
      : null;
  document.querySelectorAll('.v-reveal').forEach(function (el) {
    if (revealObserver) revealObserver.observe(el);
    else el.classList.add('is-visible');
  });

  /* ---------- Ancres douces de la nav (/#x hors accueil, #x sur place) ---------- */
  document.querySelectorAll('.v-header__nav a').forEach(function (a) {
    var href = a.getAttribute('href') || '';
    var hash = href.charAt(0) === '#' ? href.slice(1) : (href.match(/#([\w-]+)$/) || [])[1];
    if (!hash) return;
    a.addEventListener('click', function (ev) {
      var samePath = new URL(a.href).pathname === window.location.pathname;
      var target = samePath ? document.getElementById(hash) : null;
      if (target) {
        ev.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---------- FAQ : accordéon un-seul-ouvert ---------- */
  document.querySelectorAll('.v-faq__toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.closest('.v-faq__list').querySelectorAll('.v-faq__toggle').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        document.getElementById(b.getAttribute('aria-controls')).hidden = true;
      });
      if (!open) {
        btn.setAttribute('aria-expanded', 'true');
        document.getElementById(btn.getAttribute('aria-controls')).hidden = false;
      }
    });
  });

  /* ---------- Blocs produit ---------- */
  document.querySelectorAll('[data-vanta-product]').forEach(function (root) {
    var dataEl = root.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var symbol = data.currencySymbol || '$';
    var bundles = data.bundles || [];
    var variants = data.variants || [];
    var variantIndex = Math.max(0, variants.findIndex(function (v) { return v.id === data.selectedVariantId; }));
    var bundleIndex = Math.min(bundles.length - 1, 1);

    var els = {
      form: root.querySelector('[data-vanta-add-form]'),
      variantInput: root.querySelector('[data-vanta-variant-id]'),
      qtyInput: root.querySelector('[data-vanta-qty]'),
      mainImg: root.querySelector('[data-vanta-main-image]'),
      thumbs: Array.prototype.slice.call(root.querySelectorAll('.v-product__thumb')),
      swatches: Array.prototype.slice.call(root.querySelectorAll('.v-swatch')),
      colorLabel: root.querySelector('[data-vanta-color-label]'),
      price: root.querySelector('[data-vanta-price]'),
      compare: root.querySelector('[data-vanta-compare]'),
      badge: root.querySelector('[data-vanta-badge]'),
      qtyOut: root.querySelector('[data-vanta-qty-out]'),
      totalBtn: root.querySelector('[data-vanta-add-label]'),
      saveNote: root.querySelector('[data-vanta-save-note]'),
      minus: root.querySelector('[data-vanta-minus]'),
      plus: root.querySelector('[data-vanta-plus]'),
      bundles: Array.prototype.slice.call(root.querySelectorAll('.v-bundle')),
      sticky: document.querySelector('[data-vanta-sticky]'),
      stickyThumb: document.querySelector('[data-vanta-sticky-thumb]'),
      stickyTitle: document.querySelector('[data-vanta-sticky-title]'),
      stickyTotal: document.querySelector('[data-vanta-sticky-total]'),
      stickyAdd: document.querySelector('[data-vanta-sticky-add]'),
      stickyLabel: document.querySelector('[data-vanta-sticky-label]'),
      buyCol: root.querySelector('[data-vanta-buy]'),
      addBtn: root.querySelector('[data-vanta-add-btn]')
    };

    var gallerySrcForVariant = function (v) {
      if (!v) return null;
      if (v.galleryImage) return v.galleryImage;
      return v.image || null;
    };
    var galleryAltForVariant = function (v) {
      return 'Vanta lifting hooks, ' + (v && (v.display || v.option)
        ? v.display || v.option
        : '') + ', pair shown from the front';
    };

    var money = function (cents) {
      return fmtMoneyCurrency(cents, data.currencyIso, symbol);
    };

    var setMainImage = function (src, alt) {
      if (src && els.mainImg && els.mainImg.getAttribute('src') !== src) {
        els.mainImg.setAttribute('src', src);
        els.thumbs.forEach(function (t) {
          t.setAttribute(
            'aria-current',
            t.getAttribute('data-image') === src ? 'true' : 'false'
          );
        });
      }
      if (src && els.stickyThumb) els.stickyThumb.setAttribute('src', src);
      if (alt && els.mainImg) els.mainImg.setAttribute('alt', alt);
    };

    var renderVariant = function () {
      var v = variants[variantIndex] || variants[0];
      if (!v) return;
      if (els.variantInput) els.variantInput.value = v.id;
      if (els.price) els.price.textContent = money(v.price);
      if (els.compare) {
        els.compare.textContent = v.compare && v.compare > v.price ? money(v.compare) : '';
        els.compare.hidden = !(v.compare && v.compare > v.price);
      }
      if (els.badge) {
        var pct = v.compare && v.compare > v.price
          ? Math.round((1 - v.price / v.compare) * 100)
          : 0;
        els.badge.textContent = pct > 0 ? 'SAVE ' + pct + '%' : '';
        els.badge.hidden = pct <= 0;
      }
      if (els.colorLabel) els.colorLabel.textContent = v.display || v.option || '';
      els.swatches.forEach(function (s, i) {
        s.setAttribute('aria-pressed', i === variantIndex ? 'true' : 'false');
      });
      setMainImage(gallerySrcForVariant(v), galleryAltForVariant(v));
      renderTotals();
    };

    var currentUnit = function () {
      var v = variants[variantIndex] || variants[0];
      return v ? v.price : 0;
    };
    var currentCompare = function () {
      var v = variants[variantIndex] || variants[0];
      return v && v.compare ? v.compare : currentUnit();
    };

    var renderTotals = function () {
      var b = bundles[bundleIndex];
      if (!b) return;
      var qty = b.qty;
      var unit = currentUnit();
      var compare = currentCompare();
      var total = Math.round(unit * qty * (1 - b.discount / 100));
      var saved = compare * qty - total;
      if (els.qtyOut) els.qtyOut.textContent = qty;
      if (els.qtyInput) els.qtyInput.value = qty;
      if (els.totalBtn) els.totalBtn.textContent = 'Add to cart — ' + money(total);
      if (els.saveNote) {
        els.saveNote.textContent = saved > 0 ? 'You save ' + money(saved) + ' with this bundle.' : '';
      }
      var packEl = document.querySelector('[data-vanta-sticky-pack]');
      if (packEl) {
        packEl.innerHTML = (b.label || '') + ' · <b>' + money(total) + '</b>';
      } else if (els.stickyTotal) {
        els.stickyTotal.textContent = money(total);
      }
      els.bundles.forEach(function (el, i) {
        el.setAttribute('aria-pressed', i === bundleIndex ? 'true' : 'false');
      });
      if (els.minus) els.minus.disabled = bundleIndex === 0;
      if (els.plus) els.plus.disabled = bundleIndex >= bundles.length - 1;
      var v = variants[variantIndex];
      if (els.stickyTitle && v) {
        els.stickyTitle.textContent = (data.productTitle || '') + ' — ' + (v.display || v.option || '');
      }
    };

    /* Pastilles couleur */
    els.swatches.forEach(function (s, i) {
      s.addEventListener('click', function () {
        var opt = s.getAttribute('data-option');
        var found = variants.findIndex(function (v) {
          return v.option === opt;
        });
        variantIndex = found >= 0 ? found : i;
        renderVariant();
      });
    });

    /* Lots */
    els.bundles.forEach(function (el, i) {
      el.addEventListener('click', function () {
        bundleIndex = i;
        renderTotals();
      });
    });
    if (els.minus) {
      els.minus.addEventListener('click', function () {
        bundleIndex = Math.max(0, bundleIndex - 1);
        renderTotals();
      });
    }
    if (els.plus) {
      els.plus.addEventListener('click', function () {
        bundleIndex = Math.min(bundles.length - 1, bundleIndex + 1);
        renderTotals();
      });
    }

    /* Vignettes + lightbox */
    var lightbox = root.querySelector('[data-vanta-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('img') : null;
    els.thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setMainImage(t.getAttribute('data-image'));
      });
    });
    var mainButton = root.querySelector('.v-product__main-shot');
    if (mainButton && lightbox && lightboxImg) {
      mainButton.addEventListener('click', function () {
        lightboxImg.setAttribute('src', els.mainImg.getAttribute('src'));
        lightbox.hidden = false;
      });
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.closest('[data-vanta-lightbox-close]')) {
          lightbox.hidden = true;
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) lightbox.hidden = true;
      });
    }

    /* Ajout au panier */
    var setAdded = function (isAdded) {
      if (els.addBtn) els.addBtn.classList.toggle('is-added', isAdded);
      var ico = els.addBtn ? els.addBtn.querySelector('.v-added-ico') : null;
      if (ico) ico.hidden = !isAdded;
      if (els.stickyLabel) els.stickyLabel.textContent = isAdded ? 'Added' : 'Add to cart';
      if (isAdded) {
        if (els.totalBtn) els.totalBtn.textContent = 'Added to cart';
        setTimeout(function () {
          setAdded(false);
          renderTotals();
        }, 2200);
      }
    };
    var updateCounts = function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          document.querySelectorAll('[data-vanta-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
    };
    var addToCart = function () {
      if (!els.form || !els.variantInput) return;
      var payload = {
        id: parseInt(els.variantInput.value, 10),
        quantity: parseInt(els.qtyInput ? els.qtyInput.value : '1', 10)
      };
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          setAdded(true);
          updateCounts();
        })
        .catch(function () {
          /* repli : envoi classique du formulaire */
          els.form.submit();
        });
    };
    if (els.form) {
      els.form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        addToCart();
      });
    }
    if (els.stickyAdd) {
      els.stickyAdd.addEventListener('click', function () {
        addToCart();
      });
    }

    /* Barre collante : visible quand le bloc d'achat a défilé au-dessus.
       Les éléments sont re-requêtés dans le callback : des applications
       (ex. PagePilot) peuvent remplacer le DOM de section après le chargement,
       ce qui rend caduques les références prises au démarrage. */
    if ('IntersectionObserver' in window) {
      var stickyIo = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            var past = !e.isIntersecting && e.boundingClientRect.bottom < 0;
            var stickyEl = document.querySelector('[data-vanta-sticky]');
            if (stickyEl) stickyEl.classList.toggle('is-visible', past);
          });
        },
        { threshold: 0 }
      );
      var buyTarget = document.querySelector('[data-vanta-buy]');
      if (buyTarget) stickyIo.observe(buyTarget);
    }

    renderVariant();
    renderTotals();
  });
})();
